import {ConsultationEventManager} from "./../consultation.eventManger";
import {Component, ElementRef, Input, SimpleChange, ViewChild} from "@angular/core";
import {ModalService, NotificationService, UserStore} from "@digicerba/common";
import {INotificationsWebServiceClient, MessageNotificationLightDto, MessageNotificationSearchCriteria} from "@resources/resources";
import {AsiDialogService, AsiTable, AsiTableData, AsiTableRequest} from "@asi-ngtools/lib";
import * as lodash from "lodash";
import {MessageNotificationTriEnums} from "@common/enum/messagenotificationtri.enum";
import {TranslateService} from "@ngx-translate/core";
import {DetailNotificationDialog} from "@common/utils/dialog/dialog-detail-notification.component";
import {ResourceMultimediaPipe} from "app/common/utils/image/resource.multimedia.pipe";

@Component({
  selector: 'resultats-alertes',
  templateUrl: './resultats.alertes.component.html',
  host: { 'class': 'page' }
})

export class ResultatsAlertesComponent {

  @Input() searchCriteria: MessageNotificationSearchCriteria;
  @Input() termsToHighlight: string;
  @ViewChild('notificationsDataTable') notificationsTable: AsiTable<MessageNotificationLightDto>;
  @ViewChild('titre') titre: ElementRef;
  asiTableData: AsiTableData<MessageNotificationLightDto> = new AsiTableData<MessageNotificationLightDto>();
  isAdmin: boolean;
  loginUserCourant: string;
  totalNotificationsNonLues: number = 0;
  notificationsNonLuesCherchees: number = 0;
  isMarkingAsRead : boolean = false;

  constructor(userStore: UserStore, private modalService: ModalService,
              private notificationsWebServiceClient: INotificationsWebServiceClient, private translateService: TranslateService,
              private asiDialogService: AsiDialogService, private resourceMultimediaPipe: ResourceMultimediaPipe,
              private consultationEventManager: ConsultationEventManager, private notificationService : NotificationService) {
    this.isAdmin = userStore.isAdmin();
    this.loginUserCourant = userStore.getLogin();

    consultationEventManager.onMarqueCommeLu().subscribe(() => this.marquerCommeLuesBouton());
    this.refreshTable(new AsiTableRequest());
  }

  onPaginationChanged(pagination: number) {
    console.log(pagination);
    this.asiTableData.pageIndex = pagination;
    this.notificationsTable.updateData(this.asiTableData);
    this.refreshTable(new AsiTableRequest());
  }

  // Méthode permettant d'actualiser la table
  public refreshTable(asiTableRequest: AsiTableRequest) {
    if (this.termsToHighlight == null) {
      this.termsToHighlight = '';
    }
    if (this.searchCriteria == null) {
      this.searchCriteria = new MessageNotificationSearchCriteria();
    }
    this.searchCriteria.tri = MessageNotificationTriEnums.DATE_PUBLICATION.value();
    this.searchCriteria.asc = false;
    this.searchCriteria.nbrElementsPage = 20;
    this.searchCriteria.pageIndex = this.asiTableData.pageIndex;
    const messageNotificationSearchCriteria: MessageNotificationSearchCriteria = { ...asiTableRequest, ...this.searchCriteria, tri: this.searchCriteria.tri};
    this.notificationsWebServiceClient.searchMessageNotifications(messageNotificationSearchCriteria).subscribe((resultats) => {
      this.asiTableData = { paginate: true, pageIndex: resultats.pageIndex, results: resultats.results, totalElements: resultats.totalElements, totalPages: resultats.totalPages };
      this.notificationsTable.updateData(this.asiTableData);
      this.countNombreMessagesNonLus(messageNotificationSearchCriteria);
      // DIGICERBA-409 : Pourquoi on les marque lue dès la réception? Le bouton de marquage ne sert plus à rien???
      // this.marquerCommeLues();
    });
  }

  public countNombreMessagesNonLus(criteria: MessageNotificationSearchCriteria) {
    // DIGICERBA-409
    this.notificationsWebServiceClient.countSearchedNewMessageNotifications(criteria).subscribe((resultats) => {
      this.notificationsNonLuesCherchees = resultats;
    }, error =>
    {
      this.notificationService.showErrorNotification('Une erreur est survenue lors du nombre des nouveaux messages de notifications')
      console.error(error);
    });
    this.notificationsWebServiceClient.countMessageNotificationsUser("").subscribe((resultats) => {
      this.totalNotificationsNonLues = resultats;
      // Mise à jour du header
      let componentHeader = document.getElementById("compteur-notifs");
      if(componentHeader){
        console.info("Mise à jour du compteur du header", this.totalNotificationsNonLues);
        componentHeader.innerHTML = '' + this.totalNotificationsNonLues;
      }
    });
    // DIGICERBA-409
  }


  // Méthode d'ouverture de popin de details du message
  openModalDetails(id: number) {
    let userCourant = this.loginUserCourant;
    this.notificationsWebServiceClient.getMessageNotification(id).subscribe((messageNotification) => {
      if (messageNotification.canal.avecConfirmation) {
        let readers: string[] = lodash.filter(messageNotification.readers, function (value) {
          return value.userReader == userCourant;
        }).map(function (value) {
          return value.userReader;
        });
        if (readers.length < 1) {
          // Le message n'a pas été lu par l'utilsateur courant, on le met au statut "lu"
          this.marquerCommeLuMessage(id, true);
        }
      }
      lodash.forEach(this.asiTableData.results, function (value) {
        if (value.id == id) {
          value.read = true;
        }
      });
      let asiDialog = this.asiDialogService.fromComponent(DetailNotificationDialog, null);
      asiDialog.getComponent().notification = messageNotification;
    });

  }

  // Méthode d'ouverture de popin de confirmation pour la suppression d'un message
  openModalSuppression(id: number) {
    this.modalService.openConfirmDialog("MODAL.NOTIFICATIONS.SUPPRESSION_NOTIF.title", "MODAL.NOTIFICATIONS.SUPPRESSION_NOTIF.message",
      "MODAL.NOTIFICATIONS.SUPPRESSION_NOTIF.confirm",
      "MODAL.NOTIFICATIONS.SUPPRESSION_NOTIF.cancel").onDialogClose().subscribe(() => {
        this.notificationsWebServiceClient.deleteMessageNotification(id).subscribe(() => {
          lodash.remove(this.asiTableData.results, function (o) {
            return o.id == id;
          });
          this.notificationsTable.updateData(this.asiTableData);
        });
      });
  }

  ngOnChanges(change: SimpleChange) {
    if (!change.firstChange) {
      this.notificationsTable.fireRefresh();
    }
  }

  public marquerCommeLues(): void {
    let idNotifications: number[] = lodash.filter(this.asiTableData.results, function (value) {
      return value.read == false && value.canalAvecConfirmation == false;
    }).map(function (value) {
      return value.id
    });
    if (idNotifications.length > 0) {
      this.notificationsWebServiceClient.markAsReadMessageNotifications(false, {ids:idNotifications}).subscribe(() => {
      });
    }
  }

  public marquerCommeLuesBouton(): void {
     //Making messages as read
    if(this.totalNotificationsNonLues != 0) {
      this.isMarkingAsRead = true;
      this.notificationsWebServiceClient.markAllAsReadMessageNotifications(true, this.loginUserCourant
      ).subscribe(
        (res) => {
          if (res) {
            this.countNombreMessagesNonLus(this.searchCriteria);
            this.notificationService.showSuccessNotification("L'opération a été effectuée avec succes.");
          } else {
            this.notificationService.showErrorNotification("Une erreur est survenue lors de l'exécution.");
          }
          this.isMarkingAsRead = false;
        },
        (err) => {
          this.notificationService.showErrorNotification("Une erreur est survenue lors de l'exécution.");
          this.isMarkingAsRead = false;

        }
      );
    }else {
      this.notificationService.showSuccessNotification("Toutes les notifications sont lues");
    }
  }

  public marquerCommeLuMessage(idMessage: number, avecConfirmation: boolean): void {
    let idNotifications: number[] = new Array<number>();
    idNotifications.push(idMessage);
    this.notificationsWebServiceClient.markAsReadMessageNotifications(avecConfirmation, {ids:idNotifications}).subscribe(() => {
      this.totalNotificationsNonLues--;
      this.notificationsNonLuesCherchees--;
    });
  }

  public getNombreTotalAlertes(): string {
    if (this.asiTableData.totalElements > 1) {
      return this.asiTableData.totalElements + " " + this.translateService.instant("ALERTES.notifications_enregistrees");
    } else {
      return this.asiTableData.totalElements + " " + this.translateService.instant("ALERTES.notification_enregistree");
    }
  }

  public getNombreAlertesNonLues(): string {
    let retour : string = this.notificationsNonLuesCherchees + "";
    if (this.totalNotificationsNonLues > 1) {
      retour += " " + this.translateService.instant("ALERTES.notifications_non_lues");
    } else {
      retour += " " + this.translateService.instant("ALERTES.notification_non_lue");
    }
    return retour;
  }

  public getTitreEtDescription(message: MessageNotificationLightDto): string {
    return message.titre + " " + message.description;
  }

  public getUrlImage(message: MessageNotificationLightDto): string {
    return this.resourceMultimediaPipe.transform(message.canalImageId);
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/consultation/resultats/resultats.alertes.component.ts